<template>
  <el-dialog
    title="科目分配类别"
    :visible.sync="showDialog"
    width="600px"
    :append-to-body="false"
    :before-close="clearDialog"
    style="z-index: 1;"
    @open="onOpen"
  >
    <el-form
      ref="form"
      label-suffix="："
      label-width="120px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="科目分配类别" prop="subType">
        <el-select v-model="form.subType" placeholder="请选择科目分配类别">
          <el-option
            v-for="item in subTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 数据字典
import { purchaseDemandSubTypeDict } from '@/dictionary/purchase-demand'

export default {
  name: 'SubjectCategoryDialog',

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      subTypeOptions: purchaseDemandSubTypeDict.array,
      form: {
        subType: ''
      },

      rules: {
        // subType: [
        //   {
        //     required: true,
        //     message: '请选择科目分配类别',
        //     trigger: ['blur', 'change']
        //   }
        // ]
      }
    }
  },

  computed: {
    visible: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },

  created() {},

  methods: {
    onOpen() {
      this.$nextTick(() => {
        this.form.subType = ''
        this.$refs.form.resetFields()
      })
    },

    // 关闭对话框时，执行的函数
    clearDialog() {
      this.$emit('change', false)
    },
    confirm() {
      this.$refs.form.validate().then(valid => {
        if (!valid) return

        this.$confirm(`是否确定批量选择科目分配类别？`, '提示', {
          type: 'warning'
        }).then(() => {
          this.$emit('confirm', this.form.subType)
          this.clearDialog()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
